import { ReferenceFieldsForm } from "@/src/app/fields/referenceFieldsForm";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { Appointment } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import { CalendarPage } from "../calendar/calendarPage";

export async function openCalendarForAppointment({
  appointment,
  onDateSelect,
}: {
  appointment: any;
  onDateSelect: (start: string, end: string, doctorId: string) => Promise<boolean | void>;
}) {
  await openDrawer({
    id: "calendarDrawer",
    title: "Fixer une date",
    additionalClasses: ["big"],
    content: (
      <CalendarPage
        userId={getItemId(appointment.doctor)}
        patient={appointment.patient}
        onDateSelect={async (start, end, doctorId) => {
          let result = await onDateSelect(start, end, doctorId);
          if (result === false) return;
          closeDrawer("calendarDrawer");
        }}
      ></CalendarPage>
    ),
  });
}

export async function openAppointmentDemandForm(
  appointment: Appointment
): Promise<Appointment> {
  let fullAppointmentType = await apiFetch("appointmentTypes", "loadOne", {
    id: getItemId(appointment.type),
  });
  if (!fullAppointmentType?.demandForm) return appointment;
  if (!fullAppointmentType?.demandForm?.sections?.length) return appointment;
  let demandForm = fullAppointmentType?.demandForm;
  appointment.demandContent ||= {
    fieldAnswers: [],
    creator: getUserId(),
    patient: getItemId(appointment.patient),
    reference: demandForm,
    
  };

  await openDrawer({
    id: "appointmentDemandForm",
    title: "Formulaire",
    content: (
      <ReferenceFieldsForm
        patient={appointment.patient}
        reference={demandForm}
        currentAnswers={appointment.demandContent?.fieldAnswers || []}
        onChange={(newValue) => {
          appointment.demandContent!.fieldAnswers = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      if (!appointment.demandContent) throw new Error("Aucun contenu trouvé");
      let demandContent = await apiFetch("refAnswers", "addOne", {
        refAnswer: appointment.demandContent,
      });

      appointment.demandContent = demandContent;
    },
  });
  if (appointment.demandContent?.id) return appointment;
  throw new Error("La demande n'a pas été enregistrée");
}
